import { useLanguage } from "@/i18n/LanguageContext";

const langs = [
  { code: "bg", label: "BG", flag: "https://flagcdn.com/w80/bg.png", alt: "Български" },
  { code: "en", label: "EN", flag: "https://flagcdn.com/w80/gb.png", alt: "English" },
];

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      className={`flex items-center gap-3 sm:gap-2 ${className}`}
    >
      {langs.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-${l.code}-btn`}
            onClick={() => setLang(l.code)}
            aria-label={l.alt}
            title={l.alt}
            className={`flex items-center gap-1.5 transition-all duration-300 ${
              active ? "opacity-100 scale-105" : "opacity-45 hover:opacity-90"
            }`}
          >
            <img
              src={l.flag}
              alt={l.alt}
              width={24}
              height={24}
              className="w-6 h-6 rounded-full object-cover shrink-0"
            />
            <span
              className={`hidden sm:inline text-sm font-bold uppercase tracking-wide ${
                active ? "text-red-500" : "text-zinc-400"
              }`}
            >
              {l.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
